import { DependenciesApi, type DependencyResponse } from '@/features/items/api/dependencies';

interface DependencyIds {
  itemId: number;
  predecessorId: number;
  successorId: number;
}

export const createDependency = ({
  itemId,
  predecessorId,
  successorId,
}: DependencyIds): Promise<DependencyResponse> =>
  itemId === predecessorId
    ? DependenciesApi.createDependency({ itemId, successorId })
    : DependenciesApi.createDependency({ itemId, predecessorId });

export const deleteDependency = ({
  itemId,
  predecessorId,
  successorId,
}: DependencyIds): Promise<void> =>
  itemId === predecessorId
    ? DependenciesApi.deleteDependency({ itemId, successorId })
    : DependenciesApi.deleteDependency({ itemId, predecessorId });
